module.exports = __webpack_public_path__ + "static/img/jigou-qinghai-bottom.ec80cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-qinghai-bottom.png
// module id = DKn5
// module chunks = 2